import * as React from 'react';
import * as I18n from 'i18n-js';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import UserPrivacySettingModal from './user_privacy_setting_modal';

const COMPONENT_NAME = 'UserPrivacySetting';

export default function UserPrivacySetting() {
  const { thirdPartyAdDataAllowed } = useUser();
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [isChecked, setPrivacySetting] = React.useState(thirdPartyAdDataAllowed);

  const closeModal = React.useCallback(() => {
    setModalOpen(false);
  }, []);

  const openModal = React.useCallback(() => {
    setModalOpen(true);
  }, []);

  const updatePrivacySetting = React.useCallback((e) => {
    setPrivacySetting(e.target.checked);
  }, []);

  return (
    <CoreLink
      to=""
      className="site-footer-v2__link"
      onClick={openModal}
      clickEvent={{
        eventName: MParticleEventName.OpenedPrivacySettingsModal,
        componentName: COMPONENT_NAME,
      }}
    >
      <UserPrivacySettingModal
        isChecked={isChecked}
        updatePrivacySetting={updatePrivacySetting}
        onClose={closeModal}
        isOpen={isModalOpen}
      />
      {I18n.t('discovery.privacySettingsModal.privacySettings.title')}
    </CoreLink>
  );
}
